export const queryKeys = {
  auth: {
    me: () => ['auth', 'me'] as const,
    validateResetToken: (token: string) =>
      ['auth', 'validate-reset-token', token] as const,
  },
  spConsent: {
    status: () => ['sp', 'consent', 'status'] as const,
  },
  spInstrument: {
    availableList: () => ['sp', 'instruments', 'available'] as const,
    info: (instrumentId: string) => ['sp', 'instrument', instrumentId, 'info'] as const,
    status: (instrumentId: string) => ['sp', 'instrument', instrumentId, 'status'] as const,
  },
  spSignupSurvey: {
    eligibility: (userId: string) =>
      ['sp', 'signup-survey', 'eligibility', userId] as const,
  },
  publicSignupSurvey: {
    bySlug: (slug: string) => ['public', 'signup-survey', 'slug', slug] as const,
    byInstrumentId: (instrumentId: string) =>
      ['public', 'signup-survey', 'id', instrumentId] as const,
  },
  spProfile: {
    stats: () => ['sp', 'profile', 'stats'] as const,
    detail: () => ['sp', 'profile'] as const,
    completeness: () => ['sp', 'profile', 'completeness'] as const,
  },
  spSurvey: {
    session: (instrumentId: string, responseId: string) =>
      ['sp', 'survey', instrumentId, responseId, 'session'] as const,
  },
  spKyc: {
    configuration: () => ['sp', 'kyc-configuration'] as const,
  },
  spRewards: {
    summary: () => ['sp', 'rewards', 'summary'] as const,
    brands: (search?: string) => ['sp', 'rewards', 'brands', search ?? ''] as const,
    claimed: (page: number, pageSize: number) =>
      ['sp', 'rewards', 'claimed', page, pageSize] as const,
  },
  spSurveyHistory: {
    all: () => ['sp', 'survey-history'] as const,
    list: (pageSize: number) => ['sp', 'survey-history', 'list', pageSize] as const,
  },
  spNotifications: {
    all: () => ['sp', 'notifications'] as const,
    unreadCount: () => ['sp', 'notifications', 'unread-count'] as const,
    panelList: () => ['sp', 'notifications', 'panel'] as const,
    infinite: (isRead: boolean, pageSize: number) =>
      ['sp', 'notifications', 'infinite', isRead, pageSize] as const,
  },
  spAccountDeletion: {
    status: () => ['sp', 'account-deletion', 'status'] as const,
  },
} as const
